import { useEffect } from "react"
import { useAuth } from "../Context/AuthContext"
import { useNavigate } from "react-router-dom"
export const RequireAuth = ({children}) =>{
    const auth = useAuth()
    const navigate = useNavigate();
    useEffect(()=>{
       if (!auth.userInfo) navigate('/login')
    }, [])
    if (auth.userInfo){
      return children
    }
    
    
}